import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "inline-block truncate font-semibold",
  style: {"max-width":"calc(100% - 30px)","margin-bottom":"-4px"}
}
const _hoisted_2 = { class: "cursor-default" }
const _hoisted_3 = { class: "text-xs mb-0.5" }
const _hoisted_4 = { class: "list-disc list-inside" }
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "truncate" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = ["title"]
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "truncate" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = ["title"]
const _hoisted_13 = ["title"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = ["title"]
const _hoisted_16 = { class: "truncate" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = ["title"]

import { PencilIcon } from "@heroicons/vue/24/solid";
import { computed, PropType } from "vue";
import { useI18n } from "vue-i18n";
import OaiTooltip from "shared/components/other/OaiTooltip.vue";
import { useProcessClasses } from "@/composables/process";
import { UnitValue, UnitValueType } from "@/types/UnitValue";
import { getProcesses } from "@/views/unit_values/services/processTableLinkService";
import { createFormatNumber } from "@/views/unit_values/services/unitValues";
import "../styles.css";


export default /*#__PURE__*/_defineComponent({
  __name: 'TypeHeader',
  props: {
  firstHeaderRowHeight: {
    type: Number,
    required: true,
  },
  secondHeaderRowHeight: {
    type: Number,
    required: true,
  },
  columnWidth: {
    type: Number,
    required: true,
  },
  type: {
    type: String as PropType<UnitValueType>,
    required: true,
  },
  isLastType: {
    type: Boolean,
    required: false,
  },
  unitValue: {
    type: Object as PropType<UnitValue>,
    required: true,
  },
},
  emits: ["editClicked"],
  setup(__props) {

const formatNumber = createFormatNumber(useI18n().locale.value);

const props = __props;



const formatAndAddPlus = (value: number | null) => {
  if (!value) {
    return null;
  }
  const plus = value > 0 ? "+" : "";
  return `${plus}${formatNumber(value)}`;
};

const formattedTypeAdjustments = computed(() => {
  return {
    duration: formatAndAddPlus(
      props.unitValue.type_duration_factor && props.unitValue.type_duration_factor * 100,
    ),
    workforce: formatAndAddPlus(props.unitValue.type_workforce_delta),
    value: formatAndAddPlus(props.unitValue?.type_value_delta),
  };
});

const processClasses = useProcessClasses();

const processes = computed(
  () => getProcesses(props.unitValue.type, processClasses.value).processes,
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "border-t border-gray-600",
    style: _normalizeStyle(`width: ${__props.columnWidth}px`)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["p-1 text-md text-center border-b border-gray-600 bg-white", {
        'border-r': __props.isLastType,
      }]),
      style: _normalizeStyle(`height: ${__props.firstHeaderRowHeight}px`)
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(OaiTooltip, { simple: "" }, _createSlots({
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(`unit_values.types.${__props.type}.label`)), 1)
          ]),
          _: 2
        }, [
          (processes.value.length)
            ? {
                name: "tooltip",
                fn: _withCtx(() => [
                  _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("unit_values.header_included_processes")) + ":", 1),
                  _createElementVNode("ul", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(processes.value, (process) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: process,
                        class: "text-xs"
                      }, _toDisplayString(_ctx.$t(`process_classes.${process}`)), 1))
                    }), 128))
                  ])
                ]),
                key: "0"
              }
            : undefined
        ]), 1024)
      ]),
      _createVNode(_unref(PencilIcon), {
        class: "h-4 w-4 cursor-pointer inline-block ml-2",
        style: {"margin-top":"-8px"},
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('editClicked')))
      })
    ], 6),
    _createElementVNode("div", {
      class: "unitValueValueColumns border-b border-gray-600 bg-white",
      style: _normalizeStyle(`height: ${__props.secondHeaderRowHeight}px`)
    }, [
      _createElementVNode("div", {
        class: "p-1 text-md text-center border-r relative",
        title: `${_ctx.$t('unit_values.duration_label')} [${_ctx.$t('unit_values.duration_unit')}]`
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createTextVNode(_toDisplayString(_ctx.$t("unit_values.duration_label")), 1),
          _hoisted_7,
          _createTextVNode("[" + _toDisplayString(_ctx.$t("unit_values.duration_unit")) + "] ", 1)
        ]),
        (formattedTypeAdjustments.value.duration !== null)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "absolute bg-yellow-300 text-white rounded text-xs px-1 py-0.5",
              style: {"top":"-11px","left":"50%","transform":"translateX(-50%)"},
              title: formattedTypeAdjustments.value.duration ?? ''
            }, _toDisplayString(formattedTypeAdjustments.value.duration) + "%", 9, _hoisted_8))
          : _createCommentVNode("", true)
      ], 8, _hoisted_5),
      _createElementVNode("div", {
        class: "p-1 text-md text-center border-r relative",
        title: `${_ctx.$t('unit_values.workforce_label')} [${_ctx.$t('unit_values.workforce_unit')}]`
      }, [
        _createElementVNode("div", _hoisted_10, [
          _createTextVNode(_toDisplayString(_ctx.$t("unit_values.workforce_label")), 1),
          _hoisted_11,
          _createTextVNode("[" + _toDisplayString(_ctx.$t("unit_values.workforce_unit")) + "] ", 1)
        ]),
        (formattedTypeAdjustments.value.workforce !== null)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "absolute bg-yellow-300 text-white rounded text-xs px-1 py-0.5",
              style: {"top":"-11px","left":"50%","transform":"translateX(-50%)"},
              title: formattedTypeAdjustments.value.workforce ?? ''
            }, _toDisplayString(formattedTypeAdjustments.value.workforce), 9, _hoisted_12))
          : _createCommentVNode("", true)
      ], 8, _hoisted_9),
      _createElementVNode("div", {
        class: "p-1 truncate text-md text-center border-r",
        title: `${_ctx.$t('unit_values.quantity_label')} [${_ctx.$t(`unit_values.types.${__props.type}.unit`)}]`
      }, [
        _createTextVNode(_toDisplayString(_ctx.$t("unit_values.quantity_label")), 1),
        _hoisted_14,
        _createTextVNode("[" + _toDisplayString(_ctx.$t(`unit_values.types.${__props.type}.unit`)) + "] ", 1)
      ], 8, _hoisted_13),
      _createElementVNode("div", {
        class: _normalizeClass(["p-1 text-md text-center bg-gray-100 relative", {
          'border-r border-r-gray-600': __props.isLastType,
        }]),
        title: `${_ctx.$t('unit_values.unit_value_label')} [${_ctx.$t(`unit_values.types.${__props.type}.unit`)}]`
      }, [
        _createElementVNode("div", _hoisted_16, [
          _createTextVNode(_toDisplayString(_ctx.$t("unit_values.unit_value_label")), 1),
          _hoisted_17,
          _createTextVNode("[" + _toDisplayString(_ctx.$t("unit_values.unit_value_unit")) + "/" + _toDisplayString(_ctx.$t(`unit_values.types.${__props.type}.unit`)) + "] ", 1)
        ]),
        (formattedTypeAdjustments.value.value !== null)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "absolute bg-yellow-300 text-white rounded text-xs px-1 py-0.5",
              style: {"top":"-11px","left":"50%","transform":"translateX(-50%)"},
              title: formattedTypeAdjustments.value.value ?? ''
            }, _toDisplayString(formattedTypeAdjustments.value.value), 9, _hoisted_18))
          : _createCommentVNode("", true)
      ], 10, _hoisted_15)
    ], 4)
  ], 4))
}
}

})